import { MessageCircle, X } from "lucide-react";
import { useState } from "react";

// E.164 phone for the Elderra production WhatsApp business number (config-driven).
const WA_PHONE = process.env.REACT_APP_WHATSAPP_NUMBER || "919205070300";
const WA_PREFILL = encodeURIComponent("Hi Elderra! 🙏 I'd like to know more.");
const WA_LINK = `https://wa.me/${WA_PHONE}?text=${WA_PREFILL}`;

export default function WhatsAppCTA() {
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("waCtaHidden") === "1");

  if (hidden) return null;

  const dismiss = () => {
    setHidden(true);
    sessionStorage.setItem("waCtaHidden", "1");
  };

  return (
    <div
      className="mx-3 mt-2 md:mx-6 rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-2.5 flex items-start gap-2.5"
      data-testid="whatsapp-cta"
    >
      <MessageCircle className="w-5 h-5 shrink-0 mt-0.5 text-emerald-600" strokeWidth={1.75} />
      <div className="flex-1 min-w-0">
        <p className="text-sm text-emerald-900 font-medium leading-snug">
          Prefer WhatsApp? Chat with Elderra there too.
        </p>
        <a
          href={WA_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block mt-1.5 text-xs font-medium text-emerald-700 underline underline-offset-2 hover:text-emerald-900"
          data-testid="whatsapp-cta-link"
        >
          Open WhatsApp →
        </a>
      </div>
      <button
        onClick={dismiss}
        className="p-1 -m-1 text-emerald-600 hover:text-emerald-900"
        aria-label="Dismiss"
        data-testid="whatsapp-cta-dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
